// extracted by mini-css-extract-plugin
export default {"headerLogo":"HeaderLogo_headerLogo__3X7fH","logo":"HeaderLogo_logo__eB2jT"};